import { usePathology } from "./PathologyRoot";
import PathologyAdminSidebar from "./PathologyAdminSidebar";
import PathologyStudentSidebar from "./PathologyStudentSidebar";

/**
 * Sidebar column section — sits above Related 3D Models.
 */
export default function PathologySidebarSection({
  compact = true,
  minWidth = 280,
  maxWidth = 340,
}) {
  const { isAdmin } = usePathology();

  if (isAdmin) {
    return (
      <PathologyAdminSidebar
        compact={compact}
        minWidth={minWidth}
        maxWidth={maxWidth}
      />
    );
  }

  return (
    <PathologyStudentSidebar
      compact={compact}
      minWidth={minWidth}
      maxWidth={maxWidth}
    />
  );
}
